<script>
export default {
    name: "ApprovedCashOutReport",

    data() {

        return {
            cashOuts: [],
        };
    },

    mounted() {

        this.fetchCashOut().then(() => {
            window.print();
            window.onafterprint = function() { window.close(); }
        }).catch(() => {});
    },

    methods: {

        fetchCashOut() {
            let url = `AccountsReports/GetCashOutReport?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
            url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;
            url += this.$route.query.user ? `&UserName=${this.$route.query.user}` : ``;

            return this.$http.get(url).then(response => {
                this.cashOuts = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full text-center my-2">
            <h5 class="font-medium text-base">Approved Cash Outs</h5>
        </div>
        <table class="table table-bordered">
            <thead class="text-xs">
                  <tr class="flex w-full">
                      <th class="p-tiny w-1/6">Authorised By</th>
                      <th class="p-tiny w-1/6">Received By</th>
                      <th class="p-tiny w-1/6">Item</th>
                      <th class="p-tiny w-1/6">Memo</th>
                      <th class="p-tiny w-1/12">Qty</th>
                      <th class="p-tiny w-1/6">Username</th>
                      <th class="p-tiny w-1/6">Approved By</th>
                      <th class="p-tiny w-1/12">Amount</th>
                  </tr>
            </thead>
            <tbody class="text-xs flex flex-col items-center">
                <tr class="w-full flex" v-for="(cashOut, idx) in cashOuts" :key="idx">
                    <td class="p-tiny w-1/6">{{ cashOut.authorisedBy }}</td>
                    <td class="p-tiny w-1/6">{{ cashOut.receivedBy }}</td>
                    <td class="p-tiny w-1/6">{{ cashOut.item }}</td>
                    <td class="p-tiny w-1/6">{{ cashOut.memo }}</td>
                    <td class="p-tiny w-1/12">{{ cashOut.quantity }}</td>
                    <td class="p-tiny w-1/6">{{ cashOut.userName }}</td>
                    <td class="p-tiny w-1/6">{{ cashOut.approvedBy }}</td>
                    <td class="p-tiny w-1/12">{{ cashOut.amount | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>